import { FC, createContext, useEffect, useContext } from 'react';
// 组件
import { ProForm, ProInputNumber } from '../../antd';
import { SortableElement } from '@yonboo/react-sortable-hoc';
// 方法
import EdiTableContext from '../context';
// 常量
import { EditableRowProps } from '../interface';
import { FormInstance } from 'antd/lib/form';
import { STATUS_CREATED_CODE, STATUS_CREATED } from '../../constants/constant';

export const EditableRowContext = createContext<FormInstance<any> | undefined>(
  undefined,
);
const SortableItem = SortableElement((props: any) => <tr {...props} />);
/** 行 */
const EditableRow: FC<EditableRowProps> = props => {
  const { sortIndex, onValuesChange, ...restProps } = props;
  const { dispatchEdiTable, dataSource } = useContext(EdiTableContext);
  const [form] = ProForm.useForm();
  const dataRowKey = props['data-row-key'];
  useEffect(() => {
    dispatchEdiTable('addForm', { form, index: props['data-row-key'] });
    return () => {
      dispatchEdiTable('deleteForm', { index: props['data-row-key'] });
    };
  }, []);
  const handleValuesChange = (changedValues: any, values: any) => {
    const findItem = dataSource?.find?.(v => v.key === dataRowKey);
    onValuesChange?.(
      Object.values(changedValues)[0],
      changedValues,
      { ...findItem, ...values },
      dataRowKey,
      form,
    );
    form.setFieldsValue({ recordStatus: STATUS_CREATED.UPDATE });
  };
  if (dataRowKey === undefined) return <tr {...props}></tr>;
  return (
    <ProForm
      form={form}
      name={`ediTable_${dataRowKey}`}
      component={false}
      onValuesChange={handleValuesChange}
    >
      <ProForm.Item name={STATUS_CREATED_CODE} hidden={true}>
        <ProInputNumber />
      </ProForm.Item>
      <EditableRowContext.Provider value={form}>
        <SortableItem index={sortIndex} {...restProps} />
      </EditableRowContext.Provider>
    </ProForm>
  );
};

export default EditableRow;
